<template>
    <v-row no-gutters>

        <v-col cols="12" xs="12" md="12">
            <v-data-table
                :loading="loading"
                :headers="headers"
                :items="entities"
                :item-class="itemRowBackground"
                :options.sync="options"
                :server-items-length="total"
                :items-per-page="10"
                :footer-props="{ itemsPerPageOptions:[5, 10, 20] }"
                :page.sync="options.page"
                @page-count="paginationPageCount = $event"
                class="elevation-1 customization-list-table pagination-list-table sticky-table"
                @dblclick:row="(event, data) => $eventBus.$emit('open-document', { id: data.item.id, type: 'Chancellery|Documents.Document' })">

                <v-progress-linear slot="progress" height="2" color="#E43958" indeterminate></v-progress-linear>

                <template v-slot:[`item.regdate`]="{ item }">
                    <div>{{dateFormat(item.regdate, 'DD.MM.YYYY')}}</div>
                </template>

                <template v-slot:[`item.declarant`]="{ item }">
                    <div class="elipsis-text-wrap">
                        {{ item.declarant }}
                    </div>
                </template>
                
                <template v-slot:[`item.contracttimeend`]="{ item }">
                    <div>{{ item.contracttimeend ? item.contracttimeend : $t('Бессрочный') }}</div>
                </template>

                <template v-slot:[`footer.prepend`]>
                    <v-pagination
                        v-model="options.page"
                        :length="paginationPageCount"
                        :total-visible="$listPaginationTotal"
                        color="teal"
                    ></v-pagination>
                </template>
                
            </v-data-table>
        </v-col>

    </v-row>

</template>

<script>
import i18n from '@/i18n'
import { httpAPI } from "@/api/httpAPI";
import { mapActions, mapGetters } from 'vuex';

export default {
    props: {
        status: {
            type: String,
            default: null
        },
        search: {
            type: String,
            default: ""
        }
    },
    computed: {
        ...mapGetters('global/auth', { userInfo: 'getUserInfo' }),
        headers() {
            return [
                { text: i18n.t("Дог._№"), value: 'regnumber', width: '150px', orderby: 2 },
                { text: i18n.t("Дог._дата"), value: 'regdate', width: '150px', orderby: 3 },
                { text: i18n.t("С_кем_заключен"), value: 'declarant', width: '15%', orderby: 4 },
                { text: i18n.t("Суть_договора"), value: 'annotation', orderby: 5 },
                { text: i18n.t("Срок_действия"), value: 'contracttimeend', width: '150px', orderby: 6 },
            ];
        },
        options: {
            get: function() {
                return this.$store.getters['qalaQyzmet/inWork/onSign/getTableOptions'];
            },
            set: function(newValue) {
                this.$store.commit('qalaQyzmet/inWork/onSign/SET_TABLE_OPTION', newValue);
            }
        },
        collection () {
            return this.$store.getters['qalaQyzmet/inWork/getCollection'];
        },
        filter () {
            return {
                ...this.options,
                SearchStr: this.search,
            }
        },
        avaibleStatuses() {
            return this.$store.getters['documents/references/GetAvaibleStatuses'];
        }
    },
    data () {
        return {
            loading: true,
            total: 0,
            entities: [],

            prevTableFilterObject: null,
            paginationPageCount: 0,
        }
    },
    methods: {
        ...mapActions(['setOverlayVisible']),
        getStatus(item) {
            let key = '';

            if (item.registrationstate == 1 && item.executionstatus == 0 && item.paymentstatus != 2 && ![1, 2].includes(item.signaturestatus) &&  !item.hasrecipients && !item.hasresolutions) key = 'acepted'; //принят            
            if (item.registrationstate == 1 && item.executionstatus == 0 && item.paymentstatus != 2 &&  ![1, 2].includes(item.signaturestatus) && item.hasrecipients && !item.hasresolutions) key = 'consideration';
            if (item.paymentstatus == 2 && ![1, 2].includes(item.signaturestatus)) key = 'waitPayment';
            if (item.paymentstatus == 3 && ![1, 2].includes(item.signaturestatus)) key = 'paymentMade';
            if (item.registrationstate == 1 && item.executionstatus == 0 && item.paymentstatus != 2 && ![1, 2].includes(item.signaturestatus) && item.hasresolutions) key = 'onExecution';
            if (item.signaturestatus == 1) key = 'onSignatureOfApplicant';
            if (item.signaturestatus == 2) key = 'onSignatureOfServiceProvider';
            if (item.executionstatus == 1) key = 'executed';
            if (item.executionstatus == 2) key = 'refusal';

            return this.avaibleStatuses[key];
        },
        resetPage() {
            this.$store.commit('qalaQyzmet/inWork/onSign/SET_TABLE_OPTION_PAGE', 1);
        },
        itemRowBackground (item) {
            return item.readed ? '' : 'font-weight-bold';
        },
        async getData(isRefresh = false) {
            if (isRefresh === false && this.$_.isEqual(this.prevTableFilterObject, this.getTableFilterObject()))
                return;

            this.setOverlayVisible({ visible: true });    
            this.prevTableFilterObject = this.getTableFilterObject();

            this.total = 0;
            this.entities = [];
            this.loading = true;

            let response = await httpAPI({
                url: `/api/correspondence/inwork/list?type=MyDocuments.OnSign.C5&filter=${this.getTableFilterObject()}`,
                method: 'GET'
            });

            this.entities = response?.data?.Payload?.data ?? [];
            this.total = response?.data?.Payload?.total ?? 0;

            this.loading = false;
            this.setOverlayVisible({ visible: false });
        },
        getTableFilterObject() {
            var { sortBy, sortDesc, page, itemsPerPage, SearchStr, Category } = this.filter;
            let OrderDir = sortDesc.length <= 0 ? false : sortDesc[0];
            let OrderBy = this.headers.find(i => i.value == (sortBy.length <= 0 ? 'null' : sortBy[0]))?.orderby ?? -1;
            return JSON.stringify({ ExecutionStatus: 0, SignatureStatus: 2, SignerWorkplaceIds: [this.userInfo.WorkplaceId], Category, SearchStr, OrderBy, OrderDir, Limit: itemsPerPage, Offset: (page - 1) * itemsPerPage });
        },
        dateFormat (value) {
            if (!value)
                return '';

            return this.$moment(value).format('DD.MM.YYYY');
        },
    },
    watch: {
        filter: {
            handler () {
                this.getData()
            },
            deep: true,
        },
    }
}
</script>